import { CardContent, makeStyles, Theme } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { EventCode, IShipTpEvent } from '../domain/TransportPlanEvent'
import { IContainerTP } from '../service/TPContainersPlans'
import { ContainerEventRow } from './TPContainerEvents'

const cellKeys = ['step', 'status', 'initial', 'updated', 'reason']

const getEventsSequence = (containerTp: IContainerTP): EventCode[] => {
  const eventsSequence = containerTp.main.eventOrder
  return eventsSequence
}

const getLastActualEventIndex = (eventCodesSequence: EventCode[], events: Record<string, IShipTpEvent>) => {
  return eventCodesSequence.reduce((_lastActualIndex, eventCode, i) => {
    const event = events[eventCode]
    if (event && event.actual) {
      return i
    }
    return _lastActualIndex
  }, -1)
}

const useTableStyles = makeStyles<Theme>((theme) => ({
  card: {
    backgroundColor: theme.palette.action.selected,
    display: 'table',
    width: '100%',
    borderCollapse: 'collapse',
  },
  row: {
    display: 'table-row',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    fontWeight: theme.typography.fontWeightMedium,
  },
  cell: {
    display: 'table-cell',
    padding: theme.spacing(0.25, 1),
  },
}))

interface TPContainerPdadTableProps {
  containerTp: IContainerTP
}

export const TPContainerPdadTable: FC<TPContainerPdadTableProps> = ({ containerTp }) => {
  const { translate } = useI18n()
  const classes = useTableStyles()

  const eventCodesSequence = getEventsSequence(containerTp)
  const lastActualIndex = getLastActualEventIndex(eventCodesSequence, containerTp.events)

  return (
    <CardContent className={classes.card}>
      <div className={classes.row}>
        {cellKeys.map((key) => (
          <div key={key} className={classes.cell}>
            {translate(`shipment_details-containers-pdad-${key}`)}
          </div>
        ))}
      </div>
      {eventCodesSequence.map((eventCode, i) => {
        const event = containerTp.events[eventCode]
        return (
          event &&
          event.revisedTimestamp &&
          event.revisedTimestamp.date && (
            <ContainerEventRow key={eventCode} event={event} eventCode={eventCode} done={lastActualIndex >= i} />
          )
        )
      })}
    </CardContent>
  )
}
